import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiservicesService } from 'src/app/services/apiservices.service';
import { Location } from '@angular/common';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { SharedModule } from 'src/app/shared/shared.module';
import { DialogData } from 'listing-angular15';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CookieService } from 'ngx-cookie-service';

interface ChartRulerItem {
  icon: string;
  text: string;
}
interface ChallengesAndStrengthsItem {
  icon: string;
  text: string;
}
interface RelatedInsight {
  _id: string;
  typeIcon: string;
  type: string;
  title: string;
  description: string;
  link: string;
  eventTimePeriod: string;
  effective_timePeriod: string;
}

interface IngressChartDetail {
  id: string;
  title: string;
  location: string;
  timestamp: string;
  period: string;
  author: Array<string>;
  createdAt: any;
  sector_focus: Array<string>;
  importance: {
    level: string;
    color: string;
  };
  interpretation: {
    intro: string;
    body: string[];
  };
  chartRuler: ChartRulerItem[];
  challengesAndStrengths: ChallengesAndStrengthsItem[];
  tags: string[];
  relatedInsights: RelatedInsight[];
}

@Component({
  selector: 'app-ingress-chart-detail',
  templateUrl: './ingress-chart-detail.component.html',
  styleUrls: ['./ingress-chart-detail.component.scss'],
})
export class IngressChartDetailComponent {
  @ViewChild('infiniteAnchor', { static: false })
  anchor!: ElementRef<HTMLElement>;
  private io?: IntersectionObserver;
  public chartDetail: IngressChartDetail | null = null;
  public isLoading: boolean = true;
  public login_user_details: any = {};
  public paramsId: any = '';
  relatedInsights: any[] = [];
  skip = 9;
  limit = 6;
  loading = false;
  hasMore = false;
  popoverPosition = { top: 0, left: 0 };
  activeChartId: string | null = null;
  activeChart: any | null = null;

  constructor(
    private route: ActivatedRoute,
    private apiService: ApiservicesService,
    private location: Location,
    private router: Router,
    public dialog: MatDialog,
    public cookieService: CookieService,
    public activateRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.login_user_details = this.cookieService.get('login_user_details')
      ? JSON.parse(this.cookieService.get('login_user_details'))
      : {};

    this.paramsId = this.activateRoute.snapshot.params['_id'];

    if (
      this.activateRoute.snapshot.params &&
      this.activateRoute.snapshot.params['_id']
    ) {
      this.activateRoute.data.subscribe((response: any) => {
        console.log('Route Data', response);
        if (response.data && response.data.status == 'success') {
          this.chartDetail = response.data.result;
          this.relatedInsights = response.data.result.relatedInsights;
          this.hasMore = response.data.result.hasMore;
          this.isLoading = false;
        }
      });
    }
  }

  openPopover(chart: any, event: MouseEvent) {
    // Close others
    this.chartDetail?.relatedInsights.forEach(
      (c: any) => (c.showPopover = false)
    );

    chart.showPopover = true;
    this.activeChart = chart;

    const rect = (event.target as HTMLElement).getBoundingClientRect();
    this.popoverPosition = {
      top: rect.bottom + window.scrollY - 100,
      left: rect.left + window.scrollX - 100,
    };

    event.stopPropagation();
  }

  closePopover(chart?: any) {
    if (chart) {
      chart.showPopover = false;
    }
    this.activeChart = null;
  }

  getAuthorDetail(body: any) {
    let author = 'System Generated';
    if (Array.isArray(body) && body.length != 0) {
      author = `${body[0].name}(${body[0].email})`;
    }
    return author;
  }

  getFormattedDate(dateString: string): string {
    const date = new Date(dateString);

    const day = date.getDate();
    const month = date.toLocaleString('en-US', { month: 'long' });
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12 || 12;

    return `${day}${this.getOrdinalSuffix(
      day
    )} ${month}, ${year} ${hours}.${minutes} ${ampm}`;
  }

  private getOrdinalSuffix(day: number): string {
    if (day > 3 && day < 21) return 'th'; // 4-20 are all 'th'
    switch (day % 10) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  }

  ngAfterViewInit() {
    this.io = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry.isIntersecting && !this.loading && this.hasMore) {
          this.loadInsights();
        }
      },
      {
        root: null,
        rootMargin: '0px 0px 300px 0px',
        threshold: 0.01,
      }
    );

    if (this.anchor?.nativeElement) {
      this.io.observe(this.anchor.nativeElement);
    }
  }

  ngOnDestroy() {
    this.io?.disconnect();
  }

  loadInsights() {
    if (this.loading || !this.hasMore) return;

    this.loading = true;
    const payload = {
      id: this.paramsId,
      skip: this.skip,
      limit: this.limit,
    };

    this.apiService
      .getHttpDataPost('ingress-charts/get-ingress-chart-by_id', payload)
      .subscribe({
        next: (res: any) => {
          console.log(
            'new on scroll data------------>>',
            res?.result?.relatedInsights
          );

          const items = res?.result?.relatedInsights ?? [];
          this.relatedInsights = [...this.relatedInsights, ...items];

          if (!res.result.hasMore) {
            this.hasMore = false;
          } else {
            this.skip += this.limit;
          }
          this.loading = false;
        },
        error: () => {
          this.loading = false;
        },
      });
  }

  onScroll(event: any) {
    console.log('Onscroll Event Triggered');

    const element = event.target;
    if (element.scrollHeight - element.scrollTop <= element.clientHeight + 50) {
      console.log('Hase More Value----------------->>', this.hasMore);

      this.loadInsights();
    }
  }

  registerClick(_id: any) {
    this.router.navigateByUrl(`/ingress-chart-details/${_id}`);
  }
  goToTag(tag: string) {
    const encodedTag = encodeURIComponent(tag);
    this.router.navigateByUrl(`/ingress-charts-list?tags=${encodedTag}`);
  }
  goToSector(tag: string) {
    const encodedTag = encodeURIComponent(tag);
    this.router.navigateByUrl(`/ingress-charts-list?sectors=${encodedTag}`);
  }
  goBack(): void {
    this.router.navigateByUrl('/');
  }

  toggleModal(show: boolean): void {
    const dialogRef = this.dialog.open(IngressDetailsShareModal, {
      panelClass: ['custom-modalbox', 'ingress-details-share-modalbox'],
      data: {},
    });
  }
}

@Component({
  selector: 'IngressDetailsShareModal',
  templateUrl: './ingress-details-share-modal.html',
  styleUrls: ['./ingress-chart-detail.component.scss'],
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, SharedModule],
})
export class IngressDetailsShareModal {
  public prevData: any;
  public copyButtonText: string = 'Copy';

  constructor(
    public dialogRef: MatDialogRef<IngressDetailsShareModal>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public matSnackBar: MatSnackBar,
    private apiService: ApiservicesService
  ) {
    this.prevData = data;
  }

  public isLoading: boolean = false;

  ngOnInit() {}

  copyLink(): void {
    const link = `https://your-domain.com/reports/${this.prevData?.id}`;
    navigator.clipboard
      .writeText(link)
      .then(() => {
        this.copyButtonText = 'Copied!';
        this.matSnackBar.open('Link Copied Successfully !!', 'Ok', {
          duration: 5000,
        });
        setTimeout(() => {
          this.copyButtonText = 'Copy';
        }, 3000);
      })
      .catch((err) => {
        this.matSnackBar.open('Failed to copy link !!', 'Ok', {
          duration: 5000,
        });
        this.copyButtonText = 'Failed!';
        setTimeout(() => {
          this.copyButtonText = 'Copy';
        }, 3000);
      });
  }

  public closeModal() {
    this.dialogRef.close(false);
  }
}
